//老的页面 接口同意放入这里面
import api from "@/api";

 //所属设备组件名称
export const deviceComponent=(deviceTypeId)=>{ return  api.axss("get", `/ocm-gdb/failure/oilApplication/deviceComponent?deviceTypeId=${deviceTypeId}` )}


